import { fileFormToUpdate } from '@/_containers';
import type {
  InventoryFormSchema,
  InventoryUpdateSchema,
} from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import {
  booleanFormToUpdateConverter,
  currencyInput,
  nullableStringToNullableFloatConverter,
  nullableStringToNullableIntConverter,
} from '@/_schemas/generic';
import { statusToStr } from '@/_schemas/status-input';

import { skusFromToUpdateConverter } from '../components/skus/shared';
import { vendorDetailsFormToUpdate } from '../vendor-details';

export function inventoryFormToUpdate({
  inventory_category,
  inventory_volume,
  status,
  images,
  vendors,

  last_order_cost,
  weight,
  minimum_stock,
  maximum_stock,
  minimum_order,
  units_per_order,
  current_stock,
  committed,
  bin_locations,
  track_stock_quantities,
  track_serial_numbers,
  discontinued,
  logo,
  secondary_skus,
  brand,
  parent,
  children,
  vendor_details,
  ...rest
}: InventoryFormSchema): InventoryUpdateSchema {
  return {
    ...rest,
    status: statusToStr(status),
    category_id: inventory_category.id,
    inventory_volume_id: inventory_volume?.id ?? null,

    images: images.map(({ id }) => id),

    last_order_cost: currencyInput.formToUpdateConverter(last_order_cost),
    weight: nullableStringToNullableFloatConverter(weight),

    committed: nullableStringToNullableIntConverter(committed),
    current_stock: nullableStringToNullableIntConverter(current_stock),
    minimum_stock: nullableStringToNullableIntConverter(minimum_stock),
    maximum_stock: nullableStringToNullableIntConverter(maximum_stock),
    units_per_order: nullableStringToNullableIntConverter(units_per_order),
    minimum_order: nullableStringToNullableIntConverter(minimum_order),

    vendors: vendors?.map(({ id, pivot }) => ({ vendor_id: id, type: pivot?.type ?? 'secondary' })) ?? [],
    bin_locations:
      bin_locations?.map(({ id, pivot }) => ({ bin_location_id: id, type: pivot?.type ?? 'secondary' })) ?? [],

    track_stock_quantities: booleanFormToUpdateConverter(track_stock_quantities),
    track_serial_numbers: booleanFormToUpdateConverter(track_serial_numbers),
    discontinued: booleanFormToUpdateConverter(discontinued),

    logo: fileFormToUpdate(logo),

    secondary_skus: skusFromToUpdateConverter(secondary_skus),
    brand_id: brand?.id ?? null,

    parent_id: parent?.id ?? null,
    children: children?.map(({ id }, index) => ({ inventory_id: id, sort_order: index })) ?? [],
    // removes those which are not present in vendors
    vendor_details: vendorDetailsFormToUpdate(vendor_details, vendors),
  };
}
